module.exports = __webpack_public_path__ + "img/report.6dc338fa.png";